import { createSlice } from '@reduxjs/toolkit';
import * as JSTool from './JSTool';
import $ from 'jquery';

export const settingObj = {
    navIndex: 0,
    isStellars: false,
    showNewsDetailIndex: -1, //new_id, 小于0隐藏
    platform: '',
}

export const settingSlice = createSlice({
    name: 'setting',
    initialState: {
        navIndex: 0,
        isMobile: false,
        showToast: null,
        showLoading: false,
        innerHeight: window.innerHeight > 666 ? window.innerHeight : 666,
        isStellars: false, //Stellar详情
        showRegisterAlert: false,
        roleItem: {},
        showNewsDetailIndex: -1, //new_id, 小于0隐藏
        newsList: [{id:1},{id:2},{id:3}],
        platform: '',
        submitedEmail: null,
        playingMusic: false,
        showVideoAlert: null,
    },
    reducers: {
        showVideoAlert: (state, action) => {
            state.showVideoAlert = action.payload;
        },
        setPlayingMusic: (state, action) => {
            state.playingMusic = !state.playingMusic;
            const ad = $('#bg_music')[0];
            if (state.playingMusic) {
                ad.play();
            } else {
                ad.pause();
            }
        },

        setSubmitedEmail: (state, action) => {
            state.submitedEmail = action.payload;
            JSTool.saveLocalString('submit_email', action.payload);
        },

        setPlatform: (state, action) => {
            state.platform = action.payload;
            settingObj.platform = action.payload;
        },

        setNewsList: (state, action) => {
            state.newsList = action.payload;
        },
        showNewsDetailIndex: (state, action) => {
            state.showNewsDetailIndex = action.payload;
            settingObj.showNewsDetailIndex = action.payload;
        },
        setRoleItem:(state, action) => {
            state.roleItem = action.payload
        },

        showRegisterAlert: (state, action) => {
            state.showRegisterAlert = action.payload;
        },

        refreshInnerHeight: (state, action) => {
            state.innerHeight = window.innerHeight > 666 ? window.innerHeight : 666;
        },

        showLoading: (state, action) => {
            state.showLoading = action.payload;
        },

        showToast: (state, action) => {
            state.showToast = action.payload;
        },

        setNavIndex: (state, action) => {
            state.navIndex = action.payload;
            settingObj.navIndex = action.payload;
        },

        setIsMobile: (state, action) => {
            state.isMobile = action.payload;
        },

        setStellars: (state, action) => {
            state.isStellars = action.payload;
            settingObj.isStellars = action.payload;
        },

    }
});

export const settingActions = settingSlice.actions
export default settingSlice.reducer
